import { render, staticRenderFns } from "./ReporteFallas.vue?vue&type=template&id=a54f553c&scoped=true"
import script from "./ReporteFallas.vue?vue&type=script&lang=js"
export * from "./ReporteFallas.vue?vue&type=script&lang=js"
import style0 from "./ReporteFallas.vue?vue&type=style&index=0&id=a54f553c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a54f553c",
  null
  
)

export default component.exports